
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Vimannagartomumbaicabservice() {



    const cardData =
    {
        keyword: 'Viman Nagar to Mumbai Cabs Service',
        heading: 'Meghana Cab : Viman Nagar to Mumbai Cabs Service',
        headingDescription: 'Meghana Cab offers Viman Nagar to Mumbai Cabs Service, ensuring a seamless and comfortable journey from Pune’s upscale neighborhood to the bustling city of Mumbai. Whether you’re traveling for an airport transfer, business meeting, or weekend getaway, our wide range of vehicles—Sedans, SUVs, Innova Crysta, and Tempo Travellers—caters to your comfort and group size. Enjoy reliable door-to-door pickups from Viman Nagar, professional drivers, on-time service, transparent fares, and 24/7 customer support. Book your Viman Nagar to Mumbai Cab with Meghana Cab and experience stress-free, premium intercity travel.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
   {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

     "services": [
    {
      "name": "Viman Nagar to Mumbai Cab Booking",
      "description": "Easily book your cab from Viman Nagar to Mumbai through our seamless online platform. Our reliable taxi service ensures comfortable, timely, and safe transfers for all kinds of travelers, whether for business or leisure."
    },
    {
      "name": "One Way Cab Viman Nagar to Mumbai",
      "description": "Opt for our one-way cab service from Viman Nagar to Mumbai for a hassle-free direct ride. Ideal for airport transfers, meetings, or personal trips with fixed pricing and no return journey obligation."
    },
    {
      "name": "Round Trip Viman Nagar to Mumbai Taxi",
      "description": "Book a round-trip taxi for your travel between Viman Nagar and Mumbai to enjoy the convenience of a cab waiting for your return journey, saving you time and providing peace of mind."
    },
    {
      "name": "Budget Cab Hire Viman Nagar to Mumbai",
      "description": "Travel economically with our budget-friendly cab hire service from Viman Nagar to Mumbai. Our clean, well-maintained cars provide great value without compromising on comfort and safety."
    },
    {
      "name": "AC Sedan Viman Nagar to Mumbai",
      "description": "Stay cool and refreshed during your trip with our air-conditioned sedan taxis from Viman Nagar to Mumbai, perfect for individuals and small groups seeking a smooth and comfortable ride."
    },
    {
      "name": "SUV Taxi Viman Nagar to Mumbai",
      "description": "Choose our spacious and powerful SUV taxis from Viman Nagar to Mumbai, ideal for families or groups requiring extra room and luggage space on their journey."
    },
    {
      "name": "Chauffeur Driven Cab Viman Nagar to Mumbai",
      "description": "Experience professional chauffeur-driven cab service from Viman Nagar to Mumbai with courteous drivers who ensure safety, punctuality, and a pleasant travel experience."
    },
    {
      "name": "Family Trip Taxi Viman Nagar to Mumbai",
      "description": "Plan your family trip comfortably with our dedicated family cabs from Viman Nagar to Mumbai, offering ample space, safety features, and a smooth ride for passengers of all ages."
    },
    {
      "name": "Private Cab Hire Viman Nagar to Mumbai",
      "description": "Book a private cab from Viman Nagar to Mumbai for exclusive, hassle-free travel. Perfect for executives, families, and travelers seeking privacy and personalized service."
    },
    {
      "name": "Online Cab Booking Viman Nagar to Mumbai",
      "description": "Enjoy the convenience of quick and secure online cab booking from Viman Nagar to Mumbai. Get instant confirmations, easy payment options, and real-time updates on your ride."
    },
    {
      "name": "Business Travel Viman Nagar to Mumbai",
      "description": "Our specialized business travel service from Viman Nagar to Mumbai caters to professionals with timely pickups, comfortable vehicles, and efficient routes ensuring you reach your meetings on time."
    },
    {
      "name": "24-Hour Cab Viman Nagar to Mumbai",
      "description": "Avail our 24/7 cab services from Viman Nagar to Mumbai, ideal for early morning flights, late-night travel, or any time you need a reliable ride with flexible booking options."
    },
    {
      "name": "Fast Travel Cab Viman Nagar to Mumbai",
      "description": "Get quick and efficient cab booking from Viman Nagar to Mumbai with our fast travel service, ensuring prompt pickups and smooth rides without unnecessary delays."
    },
    {
      "name": "Reliable Cab Viman Nagar to Mumbai",
      "description": "Trust our reliable cab service from Viman Nagar to Mumbai that focuses on safety, vehicle maintenance, and customer satisfaction, making your journey stress-free and pleasant."
    },
    {
      "name": "Premium Cabs Viman Nagar to Mumbai",
      "description": "Upgrade your travel with our premium cab options from Viman Nagar to Mumbai featuring luxury vehicles, extra amenities, and highly trained chauffeurs for a first-class experience."
    }
  ],
  "tableData": [
    ["Viman Nagar to Mumbai Cab Booking", "One Way Cab Viman Nagar to Mumbai"],
    ["Round Trip Viman Nagar to Mumbai Taxi", "Budget Cab Hire Viman Nagar to Mumbai"],
    ["AC Sedan Viman Nagar to Mumbai", "SUV Taxi Viman Nagar to Mumbai"],
    ["Chauffeur Driven Cab Viman Nagar to Mumbai", "Family Trip Taxi Viman Nagar to Mumbai"],
    ["Private Cab Hire Viman Nagar to Mumbai", "Online Cab Booking Viman Nagar to Mumbai"],
    ["Business Travel Viman Nagar to Mumbai", "24-Hour Cab Viman Nagar to Mumbai"],
    ["Fast Travel Cab Viman Nagar to Mumbai", "Reliable Cab Viman Nagar to Mumbai"],
    ["Premium Cabs Viman Nagar to Mumbai", ""]
  ],




"whychoose": [
    {
        "WhyChooseheading": "Reliable Viman Nagar to Mumbai Cab Service for Seamless Travel",
        "WhyChoosedescription": "Our cab service from Viman Nagar to Mumbai ensures timely pickups and smooth rides, whether you’re traveling for business, airport transfers, or leisure. We prioritize punctuality and customer satisfaction, making your journey stress-free and enjoyable."
    },
    {
        "WhyChooseheading": "Well-Maintained and Comfortable Vehicles",
        "WhyChoosedescription": "Travel in air-conditioned, clean, and spacious cars that are regularly serviced and sanitized. Our fleet includes a range of vehicle options to match your comfort needs, ensuring a pleasant and safe journey no matter the distance."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are trained, courteous, and familiar with the best routes from Viman Nagar to Mumbai. They follow all safety protocols and provide friendly service to ensure your ride is both safe and enjoyable."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "We offer upfront, all-inclusive pricing that covers fuel, tolls, taxes, and driver allowances. Our transparent fare system means you’ll never face surprise fees or unexpected costs, allowing you to plan your trip confidently."
    },
    {
        "WhyChooseheading": "Flexible Booking and Customized Itineraries",
        "WhyChoosedescription": "Whether you need a one-way trip, round-trip, or hourly rental, we provide flexible booking options to suit your schedule. Customize pickup and drop-off points anywhere within Viman Nagar and Mumbai for a tailored travel experience."
    },
    {
        "WhyChooseheading": "Door-to-Door Pickup and Drop-off",
        "WhyChoosedescription": "Enjoy the convenience of our door-to-door service, with pickups and drop-offs at your preferred locations in Viman Nagar and Mumbai. This eliminates the need for multiple transfers or waiting at cab stands, saving you time and effort."
    },
    {
        "WhyChooseheading": "Ideal for Airport Transfers, Corporate Travel, and Family Trips",
        "WhyChoosedescription": "Our cabs are well-suited for all types of travel, from airport transfers and business trips to family outings and personal visits. Experience comfort and reliability on every journey."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Online Booking",
        "WhyChoosedescription": "Our customer support team is available around the clock to assist with bookings, modifications, or special requests. With our easy-to-use online booking platform, you can schedule your cab anytime, ensuring a hassle-free experience."
    }
]





















    }

const faqData = [
    {
        question: "How can I book a cab from Viman Nagar to Mumbai?",
        answer: "You can book a cab easily by calling Meghana Cab at +91 9075462128 or through our website for instant booking."
    },
    {
        question: "What is the estimated travel time from Viman Nagar to Mumbai?",
        answer: "The travel time is typically around 3 to 4 hours, depending on traffic conditions and time of day."
    },
    {
        question: "Do you offer both one way and round trip services from Viman Nagar to Mumbai?",
        answer: "Yes, we offer both one way and round trip cab options to suit your travel plans."
    },
    {
        question: "What types of vehicles are available for the Viman Nagar to Mumbai route?",
        answer: "We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to match your group size and comfort."
    },
    {
        question: "Is the cab service available 24/7 from Viman Nagar?",
        answer: "Yes, our cab services operate 24/7 to serve you at any hour, including early mornings and late nights."
    },
    {
        question: "What’s included in the fare for this trip?",
        answer: "The fare includes fuel, tolls, and driver charges. Additional charges may apply for extra stops or waiting time."
    },
    {
        question: "Can I make a last-minute booking from Viman Nagar to Mumbai?",
        answer: "Yes, last-minute bookings are accepted based on vehicle availability. We recommend calling for faster confirmation."
    },
    {
        question: "Can I book the cab online?",
        answer: "Yes, online booking is available 24/7 through our secure website for your convenience."
    },
    {
        question: "Can I request stops during the journey for food or rest?",
        answer: "Yes, you can request rest or meal breaks. Just inform us during booking or speak to your driver."
    },
    {
        question: "Are the drivers trained and experienced for long-distance travel?",
        answer: "Absolutely. All our drivers are professional, trained, and experienced on the Viman Nagar to Mumbai route."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Nikhil Shinde',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Top-notch service from Viman Nagar to Mumbai. On-time pickup and very comfortable ride with Meghana Cab.”',
    },
    {
        name: 'Ms. Pooja Gokhale',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Clean cab, smooth driving, and polite driver. Booking was quick and easy. Great service overall!”',
    },
];






























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Viman Nagar to Mumbai Cabs Service",
  "image": "https://www.meghanacabs.com/assets/images/viman-nagar-to-mumbai-cab.jpg",
  "description": "Reliable and comfortable cab service from Viman Nagar to Mumbai by Meghana Cabs. Choose from budget, AC sedan, SUV, and chauffeur-driven cabs for one-way and round trips. Family and business travel options available. Book online 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/viman-nagar-to-mumbai-cabs-service"
  }
};







    return (
        <div>

<Helmet>
  <title>Viman Nagar to Mumbai Cabs Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book reliable Viman Nagar to Mumbai cab service with Meghana Cabs. Budget, AC sedan, SUV, and chauffeur-driven cabs available for one-way and round trips. Family and business travel options. Online booking 24/7." 
  />
  <meta 
    name="keywords" 
    content="Viman Nagar to Mumbai Cab Booking, One Way Cab Viman Nagar to Mumbai, Round Trip Viman Nagar to Mumbai Taxi, Budget Cab Hire Viman Nagar to Mumbai, AC Sedan Viman Nagar to Mumbai, SUV Taxi Viman Nagar to Mumbai, Chauffeur Driven Cab Viman Nagar to Mumbai, Family Trip Taxi Viman Nagar to Mumbai, Private Cab Hire Viman Nagar to Mumbai, Online Cab Booking Viman Nagar to Mumbai, Business Travel Viman Nagar to Mumbai, 24-Hour Cab Viman Nagar to Mumbai, Fast Travel Cab Viman Nagar to Mumbai, Reliable Cab Viman Nagar to Mumbai, Premium Cabs Viman Nagar to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/61.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Vimannagartomumbaicabservice;